import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import { PolicyEvaluation } from '../../order-eligibility-display.service';

interface EligiblePoliciesSectionProps {
    eligiblePolicyEvaluations: PolicyEvaluation[];
}

const EligiblePoliciesSection: React.FC<EligiblePoliciesSectionProps> = ({ 
    eligiblePolicyEvaluations 
}) => {
    if (eligiblePolicyEvaluations.length === 0) {
        return null;
    }

    return (
        <div className="eligible-policies-section">
            <FontBody2 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                Eligible Policies:
            </FontBody2>
            {eligiblePolicyEvaluations.map((policyEvaluation, policyIndex) => (
                <div key={policyIndex} className="policy-item">
                    <FontBody2 color={FONT_COLOR.PRIMARY1} variant={[FONT_VARIANT.BOLD]}>
                        {policyEvaluation.policy_name}
                        {policyEvaluation.resolution && (
                            <span className="resolution-category">
                                {' '}({policyEvaluation.resolution.resolution_category})
                            </span>
                        )}
                    </FontBody2>
                </div>
            ))}
        </div>
    );
};

export default EligiblePoliciesSection;
